<template>
  <div>
    <!-- 轮播图 -->
    <swiper title="频谱仪软件" :bannerList="bannerList"></swiper>

    <!-- 项目背景 -->
    <section class="d-flex align-items-center pt-4 pb-4 text-line-height-1" data-aos="fade-up">
      <div class="container">
        <main-title title="项目背景"></main-title>
        <retract-list :dataList="projectList"></retract-list>
      </div>
    </section>

    <!-- 核心功能 -->
    <section class="d-flex align-items-center pt-4 text-line-height-1" data-aos="fade-up">
      <div class="container">
        <main-title title="核心功能"></main-title>
        <div class="indentation pb-3">
          <desc-list :dataList="lightSpotList"></desc-list>
        </div>
        <card-list :dataList="highList"></card-list>
      </div>
    </section>
  </div>
</template>

<script>
import Swiper from '@/components/Swiper.vue'
export default {
  name: 'SpectroGraph',
  components: { Swiper,},
  props: {},
  data() {
    return {
      bannerList: [{ src: require('@/assets/img/common/caseList/spectroGraph/banner1.png') }, { src: require('@/assets/img/common/caseList/spectroGraph/banner2.png') }],
      projectList: ['《选频式电磁辐射分析仪软件》是一款根据选频式电磁辐射分析仪定制化开发的一套操作软件。该软件可以接收仪器数据进行数据分析，同时也能操作仪器天线进行切轴、设置仪器参数等功能。'],
      lightSpotList: [
        {
          title: '频谱分析模式：',
          titleDetail: '频谱分析模式用于对空间中电磁环境频谱状况进行测量，该模式下可以自动识别选频探头的天线系数，任意设置探头频段范围内的起始和终止频率，可以对频谱中任意频段进行积分计算；自动识别最大值频点，可标记频谱内任意频点的信息，选择不同的电磁控制限值曲线，得到标记频点与限值的百分比；可以同时画出最大值、实时值、平均值等曲线，支持对数据进行二次计算处理，单次测量任务可截屏保存图片文件，测量结果保存Excel文件，可通过USB通信接口导出。',
        },
        {
          title: '仪表分析模式：',
          titleDetail: '列表分析模式用于对已知工作频段的信号的快速测量，该模式下可直接完成多个已知频段的积分计算，得到各频段的积分值，内置国标8702-2014电磁控制限值曲线，可以得到该频段的积分值与限值的百分比；该模式内置移动、联通、电信、广电运营商的各个工作频段，并且可以得到各个运营商总的积分值和限值百分比；可以任意添加若干个自定义的列表，每个列表亦可以增加若干个频段，用户可随意选择列表进行测量。',
        },
        {
          title: '快速测量模式：',
          titleDetail: '快速测量模式支持用户进行测量任务的预设，自定义编辑任务名称、起始终止频段、分辨率带宽、积分频段范围、任务时间等各项参数。设置完成后保存为自定义测量任务，用户可选择该任务直达测量界面无需重新设置各项参数。',
        },
        {
          title: '系统设置：',
          titleDetail: '系统设置用来设置文件保存路径和查看文件内容；设置仪器内置WIFI的连接状态；查询仪器内存剩余容量及清理存储数据；查看仪器出厂信息，电池续航等信息。',
        },
      ],
      highList: [
        {
          src: require("@/assets/img/common/spectroGraph/highlights1.png"),
          smSrc: require("@/assets/img/common/spectroGraph/highlights1-s.png"),
          title: '频谱分析模式',
          col:6
        },
        {
          src: require("@/assets/img/common/spectroGraph/highlights2.png"),
          smSrc: require("@/assets/img/common/spectroGraph/highlights2-s.png"),
          title: '仪表分析模式',
          col:6
        },
        {
          src: require("@/assets/img/common/spectroGraph/highlights3.png"),
          smSrc: require("@/assets/img/common/spectroGraph/highlights3-s.png"),
          title: '快速测量模式',
          col:6
        },
        {
          src: require("@/assets/img/common/spectroGraph/highlights4.png"),
          smSrc: require("@/assets/img/common/spectroGraph/highlights4-s.png"),
          title: '系统设置',
          col:6
        },
      ]
    }
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
}
</script>
<style scoped></style>
